import React, { useMemo, useState, useEffect } from "react";
import { UserProvider } from "context/userContext";
import UserProfile from "layouts/gestionUsers/component/UserProfile";
import { useLocation, useNavigate } from "react-router-dom";
import BackButton from "components/BackButton";
import servicesAPI from "services/servicesAPI";
import LoadComponent from "components/LoadComponent";
import ModuleTitle from "components/ModuleTitle";
// import { Grid } from "@mui/material";
// import GestionLotPuce from "layouts/donneeReference/rubrique/gestionLotPuce";
import { AGENT_ROLE } from "constant/role";
import { Box } from "@mui/system";
import MDButton from "components/MDButton";
import { PATH_LOT_PUCE } from "constant/moduleInfo";

function DetailUser() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { selectedData, niveau, roleTitle, permissionModule } = state;
  const { isAlert, isLoading, message, alertSeverity, handleLoad, getData, putData, postData } =
    servicesAPI();
  const [title, setTitle] = useState("");
  const loadDataConfig = useMemo(() => {
    const value = {
      isAlert,
      isLoading,
      message,
      alertSeverity,
      handleLoad,
    };
    return value;
  }, [isAlert, isLoading, message, alertSeverity]);
  const propsDataConfig = useMemo(() => {
    const value = {
      selectedData,
      niveau,
      roleTitle,
      ApiService: { getData, putData, postData },
      handleLoad,
      permissionModule,
    };
    return value;
  }, [selectedData, niveau]);
  useEffect(() => {
    if (selectedData) {
      setTitle(`Détails Compte Utilisateur ${roleTitle}`);
    } else {
      setTitle(`Création Compte Utilisateur ${roleTitle}`);
    }
  }, [selectedData]);

  const goToListLotPuce = () => {
    navigate(PATH_LOT_PUCE, { state: { agent: selectedData } });
  };
  return (
    <>
      <ModuleTitle title={title} />
      <BackButton />

      <UserProvider propsDataConfig={propsDataConfig}>
        <UserProfile />
      </UserProvider>
      {/* selectedData?.roles?.some((i) => i.roleName === AGENT_ROLE) && (
        <Grid item xs={12} sx={{ marginTop: 5 }}>
          <GestionLotPuce agent={selectedData} />
        </Grid>
      ) */}
      {selectedData?.roles?.some((i) => i.roleName === AGENT_ROLE) && (
        <Box display="flex" alignItems="center" justifyContent="center">
          <MDButton type="submit" variant="gradient" color="info" onClick={goToListLotPuce}>
            Voir la liste des lots de puce de l&apos;agent
          </MDButton>
        </Box>
      )}
      <LoadComponent loadData={loadDataConfig} />
    </>
  );
}

export default DetailUser;
